import { UPDATE_PARTNER_CLIENT_ACCOUNT_EMPLOYEE } from '@/common/actions/update';
import { validationSchemaUserInformation } from '../../store';
import { yupResolver } from '@hookform/resolvers/yup';
import { useMutation } from '@apollo/client';
import { Box, Button, Input, TextField, Typography } from '@servicepipe/ui-components';
import React, { useEffect, useRef } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { toast } from 'react-toastify';

export const UserInformationForm = ({ employee, userId }) => {
  const initialized = useRef(false);

  const [updateEmployee, { loading }] = useMutation(UPDATE_PARTNER_CLIENT_ACCOUNT_EMPLOYEE, {
    onCompleted: () => toast.success('Success'),
    onError: (error) => toast.error(error.message),
  });

  const {
    handleSubmit,
    control,
    reset,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(validationSchemaUserInformation),
    defaultValues: { firstName: '', lastName: '' },
  });

  useEffect(() => {
    if (!employee || initialized.current) {
      return;
    }

    reset({
      firstName: employee.name?.first ?? '',
      lastName: employee.name?.last ?? '',
    });
    initialized.current = true;
  }, [employee, reset]);

  return (
    <Box direction="column" gap="20px" width="550px">
      <Typography variant="h6">User Information</Typography>

      <form
        onSubmit={handleSubmit((formData) =>
          updateEmployee({
            variables: {
              id: userId,
              name: {
                first: formData.firstName,
                last: formData.lastName,
              },
            },
          })
        )}
      >
        <Box direction="column" gap="20px">
          <Controller
            name="firstName"
            control={control}
            render={({ field: { onChange, value } }) => (
              <TextField
                id="firstName"
                label="First Name"
                isError={Boolean(errors?.firstName)}
                helperText={errors?.firstName?.message || ''}
              >
                <Input width="100%" value={value} onChange={onChange} />
              </TextField>
            )}
          />

          <Controller
            name="lastName"
            control={control}
            render={({ field: { onChange, value } }) => (
              <TextField
                id="lastName"
                label="Last Name"
                isError={Boolean(errors?.lastName)}
                helperText={errors?.lastName?.message || ''}
              >
                <Input width="100%" value={value} onChange={onChange} />
              </TextField>
            )}
          />

          <TextField id="email" label="Email" isDisabled>
            <Input width="100%" value={employee?.email ?? ''} isDisabled />
          </TextField>

          <Box justify="right" width="100%">
            <Button type="submit" variant="solid" color="accent" isLoading={loading}>
              Save
            </Button>
          </Box>
        </Box>
      </form>
    </Box>
  );
};
